import React from 'react';
import { Container } from 'react-bootstrap';
import './NewsSection.css';
import AnimatedSection from './AnimatedSection';


function NewsSection ()  {
    return (
        <div>
            <Container>
                <ul className='news__section'>

                    <div class="row">
                        <div className='col'>
                            <p className='alerts slide-left-text'>Alerts</p>
                            <AnimatedSection/>
                            <p className='some__text'>Verify the RTU test schedule, result, and admit card. This website, Quicklearn, was created with students in mind and makes available all RTU-related news. You may now contribute to Quicklearn to assist other students. Every student has access to Quicklearn.
                                 </p>
                            
                        </div>


                        <div className='col'>
                            <div className='row'>
                        <div class="col">
                            <li>
                                <a href='https://rtu.sumsraj.com/Exam/Report/DownloadGradesheet.aspx'> <button className='news_url diagonal-hoverr'> <div className='contentt'> Recent Declared Results </div> </button> </a>
                            </li>
                        </div>
                        <div class="col">
                        <li>
                            <a href='https://rtu.ac.in/index/view_menudata.php?page=Time-Table29' > <button className='news_url diagonal-hoverr'> <div className='contentt'> Exam Time Table </div> </button> </a>
                        </li>
                        </div>
                        <div class="col">
                            <li>
                                <a href='https://rtu.sumsraj.com/' ><button className='news_url diagonal-hoverr'> <div className='contentt'> Admit Card </div> </button> </a>
                            </li>
                        </div>
                        </div>
                        </div>
                </div>
                </ul>    
            </Container>    
            <hr/>
        </div>
    );
}

export default NewsSection;
